/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeambulazioneAusilioCreateDTO,
  DeambulazioneAusilioDTO,
  DeambulazioneAusilioUpdateDTO,
  DeambulazioneTipoCreateDTO,
  DeambulazioneTipoDTO,
  DeambulazioneTipoUpdateDTO,
  ProblemDetails,
  TipoContattoCreateDTO,
  TipoContattoDTO,
  TipoContattoUpdateDTO,
} from '../models/index';
import {
    DeambulazioneAusilioCreateDTOFromJSON,
    DeambulazioneAusilioCreateDTOToJSON,
    DeambulazioneAusilioDTOFromJSON,
    DeambulazioneAusilioDTOToJSON,
    DeambulazioneAusilioUpdateDTOFromJSON,
    DeambulazioneAusilioUpdateDTOToJSON,
    DeambulazioneTipoCreateDTOFromJSON,
    DeambulazioneTipoCreateDTOToJSON,
    DeambulazioneTipoDTOFromJSON,
    DeambulazioneTipoDTOToJSON,
    DeambulazioneTipoUpdateDTOFromJSON,
    DeambulazioneTipoUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    TipoContattoCreateDTOFromJSON,
    TipoContattoCreateDTOToJSON,
    TipoContattoDTOFromJSON,
    TipoContattoDTOToJSON,
    TipoContattoUpdateDTOFromJSON,
    TipoContattoUpdateDTOToJSON,
} from '../models/index';

export interface DeleteDeambulazioneAusilioRequest {
    deambulazioneAusilioId: string;
    tenantId: string;
}

export interface DeleteDeambulazioneTipoRequest {
    deambulazioneTipoId: string;
    tenantId: string;
}

export interface DeleteTipoContattoRequest {
    tipoContattoId: string;
    tenantId: string;
}

export interface GetDeambulazioneAusiliRequest {
    tenantId: string;
}

export interface GetDeambulazioneAusilioByIdRequest {
    deambulazioneAusilioId: string;
    tenantId: string;
}

export interface GetDeambulazioneTipiRequest {
    tenantId: string;
}

export interface GetDeambulazioneTipoByIdRequest {
    deambulazioneTipoId: string;
    tenantId: string;
}

export interface GetTipiContattiRequest {
    tenantId: string;
}

export interface GetTipoContattoByIdRequest {
    tipoContattoId: string;
    tenantId: string;
}

export interface InsertDeambulazioneAusilioRequest {
    tenantId: string;
    deambulazioneAusilioCreateDTO?: DeambulazioneAusilioCreateDTO;
}

export interface InsertDeambulazioneTipoRequest {
    tenantId: string;
    deambulazioneTipoCreateDTO?: DeambulazioneTipoCreateDTO;
}

export interface InsertTipoContattoRequest {
    tenantId: string;
    tipoContattoCreateDTO?: TipoContattoCreateDTO;
}

export interface UpdateDeambulazioneAusilioRequest {
    deambulazioneAusilioId: string;
    tenantId: string;
    deambulazioneAusilioUpdateDTO?: DeambulazioneAusilioUpdateDTO;
}

export interface UpdateDeambulazioneTipoRequest {
    deambulazioneTipoId: string;
    tenantId: string;
    deambulazioneTipoUpdateDTO?: DeambulazioneTipoUpdateDTO;
}

export interface UpdateTipoContattoRequest {
    tipoContattoId: string;
    tenantId: string;
    tipoContattoUpdateDTO?: TipoContattoUpdateDTO;
}

/**
 * 
 */
export class AnagraficheApi extends runtime.BaseAPI {

    /**
     */
    async deleteDeambulazioneAusilioRaw(requestParameters: DeleteDeambulazioneAusilioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deambulazioneAusilioId'] == null) {
            throw new runtime.RequiredError(
                'deambulazioneAusilioId',
                'Required parameter "deambulazioneAusilioId" was null or undefined when calling deleteDeambulazioneAusilio().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteDeambulazioneAusilio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneAusili/{deambulazioneAusilioId}`.replace(`{${"deambulazioneAusilioId"}}`, encodeURIComponent(String(requestParameters['deambulazioneAusilioId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDeambulazioneAusilio(requestParameters: DeleteDeambulazioneAusilioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDeambulazioneAusilioRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDeambulazioneTipoRaw(requestParameters: DeleteDeambulazioneTipoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deambulazioneTipoId'] == null) {
            throw new runtime.RequiredError(
                'deambulazioneTipoId',
                'Required parameter "deambulazioneTipoId" was null or undefined when calling deleteDeambulazioneTipo().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteDeambulazioneTipo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneTipi/{deambulazioneTipoId}`.replace(`{${"deambulazioneTipoId"}}`, encodeURIComponent(String(requestParameters['deambulazioneTipoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDeambulazioneTipo(requestParameters: DeleteDeambulazioneTipoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDeambulazioneTipoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTipoContattoRaw(requestParameters: DeleteTipoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tipoContattoId'] == null) {
            throw new runtime.RequiredError(
                'tipoContattoId',
                'Required parameter "tipoContattoId" was null or undefined when calling deleteTipoContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteTipoContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/TipiContatti/{tipoContattoId}`.replace(`{${"tipoContattoId"}}`, encodeURIComponent(String(requestParameters['tipoContattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTipoContatto(requestParameters: DeleteTipoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTipoContattoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDeambulazioneAusiliRaw(requestParameters: GetDeambulazioneAusiliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeambulazioneAusilioDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getDeambulazioneAusili().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneAusili`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeambulazioneAusilioDTOFromJSON));
    }

    /**
     */
    async getDeambulazioneAusili(requestParameters: GetDeambulazioneAusiliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeambulazioneAusilioDTO>> {
        const response = await this.getDeambulazioneAusiliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeambulazioneAusilioByIdRaw(requestParameters: GetDeambulazioneAusilioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeambulazioneAusilioDTO>> {
        if (requestParameters['deambulazioneAusilioId'] == null) {
            throw new runtime.RequiredError(
                'deambulazioneAusilioId',
                'Required parameter "deambulazioneAusilioId" was null or undefined when calling getDeambulazioneAusilioById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getDeambulazioneAusilioById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneAusili/{deambulazioneAusilioId}`.replace(`{${"deambulazioneAusilioId"}}`, encodeURIComponent(String(requestParameters['deambulazioneAusilioId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeambulazioneAusilioDTOFromJSON(jsonValue));
    }

    /**
     */
    async getDeambulazioneAusilioById(requestParameters: GetDeambulazioneAusilioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeambulazioneAusilioDTO> {
        const response = await this.getDeambulazioneAusilioByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeambulazioneTipiRaw(requestParameters: GetDeambulazioneTipiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeambulazioneTipoDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getDeambulazioneTipi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneTipi`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeambulazioneTipoDTOFromJSON));
    }

    /**
     */
    async getDeambulazioneTipi(requestParameters: GetDeambulazioneTipiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeambulazioneTipoDTO>> {
        const response = await this.getDeambulazioneTipiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeambulazioneTipoByIdRaw(requestParameters: GetDeambulazioneTipoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeambulazioneTipoDTO>> {
        if (requestParameters['deambulazioneTipoId'] == null) {
            throw new runtime.RequiredError(
                'deambulazioneTipoId',
                'Required parameter "deambulazioneTipoId" was null or undefined when calling getDeambulazioneTipoById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getDeambulazioneTipoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneTipi/{deambulazioneTipoId}`.replace(`{${"deambulazioneTipoId"}}`, encodeURIComponent(String(requestParameters['deambulazioneTipoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeambulazioneTipoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getDeambulazioneTipoById(requestParameters: GetDeambulazioneTipoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeambulazioneTipoDTO> {
        const response = await this.getDeambulazioneTipoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTipiContattiRaw(requestParameters: GetTipiContattiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TipoContattoDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTipiContatti().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/TipiContatti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TipoContattoDTOFromJSON));
    }

    /**
     */
    async getTipiContatti(requestParameters: GetTipiContattiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TipoContattoDTO>> {
        const response = await this.getTipiContattiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTipoContattoByIdRaw(requestParameters: GetTipoContattoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TipoContattoDTO>> {
        if (requestParameters['tipoContattoId'] == null) {
            throw new runtime.RequiredError(
                'tipoContattoId',
                'Required parameter "tipoContattoId" was null or undefined when calling getTipoContattoById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTipoContattoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/TipiContatti/{tipoContattoId}`.replace(`{${"tipoContattoId"}}`, encodeURIComponent(String(requestParameters['tipoContattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TipoContattoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getTipoContattoById(requestParameters: GetTipoContattoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TipoContattoDTO> {
        const response = await this.getTipoContattoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertDeambulazioneAusilioRaw(requestParameters: InsertDeambulazioneAusilioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeambulazioneAusilioDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertDeambulazioneAusilio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneAusili`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeambulazioneAusilioCreateDTOToJSON(requestParameters['deambulazioneAusilioCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeambulazioneAusilioDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertDeambulazioneAusilio(requestParameters: InsertDeambulazioneAusilioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeambulazioneAusilioDTO> {
        const response = await this.insertDeambulazioneAusilioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertDeambulazioneTipoRaw(requestParameters: InsertDeambulazioneTipoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeambulazioneTipoDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertDeambulazioneTipo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneTipi`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeambulazioneTipoCreateDTOToJSON(requestParameters['deambulazioneTipoCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeambulazioneTipoDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertDeambulazioneTipo(requestParameters: InsertDeambulazioneTipoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeambulazioneTipoDTO> {
        const response = await this.insertDeambulazioneTipoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertTipoContattoRaw(requestParameters: InsertTipoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TipoContattoDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertTipoContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/TipiContatti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TipoContattoCreateDTOToJSON(requestParameters['tipoContattoCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TipoContattoDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertTipoContatto(requestParameters: InsertTipoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TipoContattoDTO> {
        const response = await this.insertTipoContattoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDeambulazioneAusilioRaw(requestParameters: UpdateDeambulazioneAusilioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deambulazioneAusilioId'] == null) {
            throw new runtime.RequiredError(
                'deambulazioneAusilioId',
                'Required parameter "deambulazioneAusilioId" was null or undefined when calling updateDeambulazioneAusilio().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateDeambulazioneAusilio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneAusili/{deambulazioneAusilioId}`.replace(`{${"deambulazioneAusilioId"}}`, encodeURIComponent(String(requestParameters['deambulazioneAusilioId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeambulazioneAusilioUpdateDTOToJSON(requestParameters['deambulazioneAusilioUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDeambulazioneAusilio(requestParameters: UpdateDeambulazioneAusilioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDeambulazioneAusilioRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateDeambulazioneTipoRaw(requestParameters: UpdateDeambulazioneTipoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deambulazioneTipoId'] == null) {
            throw new runtime.RequiredError(
                'deambulazioneTipoId',
                'Required parameter "deambulazioneTipoId" was null or undefined when calling updateDeambulazioneTipo().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateDeambulazioneTipo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/DeambulazioneTipi/{deambulazioneTipoId}`.replace(`{${"deambulazioneTipoId"}}`, encodeURIComponent(String(requestParameters['deambulazioneTipoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeambulazioneTipoUpdateDTOToJSON(requestParameters['deambulazioneTipoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDeambulazioneTipo(requestParameters: UpdateDeambulazioneTipoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDeambulazioneTipoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTipoContattoRaw(requestParameters: UpdateTipoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tipoContattoId'] == null) {
            throw new runtime.RequiredError(
                'tipoContattoId',
                'Required parameter "tipoContattoId" was null or undefined when calling updateTipoContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTipoContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/TipiContatti/{tipoContattoId}`.replace(`{${"tipoContattoId"}}`, encodeURIComponent(String(requestParameters['tipoContattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TipoContattoUpdateDTOToJSON(requestParameters['tipoContattoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTipoContatto(requestParameters: UpdateTipoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTipoContattoRaw(requestParameters, initOverrides);
    }

}
